import { useSelector } from 'react-redux'
import { valToPercent } from '../../../helpers/value'
import { Table } from './../../../common/table/index'

const COLUMNS = {
  NAME: 'name',
  POSITION: 'position',
  SHAREHOLDING: 'shareholding',
}

export const Management = ({ data }) => {
  const locale = useSelector((state) => state.i18n.locale)

  const ids = data.map((_, index) => index)

  const getSchema = () => {
    return Object.keys(COLUMNS).map((key) => {
      const title = `alertDetail.${key}`
      const colId = COLUMNS[key]
      const parentThStyle = { backgroundColor: '#F3F3F3' }
      const thStyle = {
        backgroundColor: '#F3F3F3',
        justifyContent: colId === COLUMNS.SHAREHOLDING ? 'flex-end' : '',
      }
      const tdStyle = ({ isHovered, isEvenRow }) => ({
        textAlign: colId === COLUMNS.SHAREHOLDING ? 'right' : 'left',
        backgroundColor: isHovered
          ? '#EDF5FE'
          : isEvenRow
          ? '#F9F9F9'
          : '#F3F3F3',
      })

      return {
        colId,
        title,
        isI18n: true,
        parentThStyle,
        thStyle,
        tdStyle,
        render: (_, { rowIndex }) => {
          const value = data[rowIndex]?.[colId]
          switch (colId) {
            case COLUMNS.SHAREHOLDING:
              return valToPercent(value, locale)
            default:
              return value
          }
        },
      }
    })
  }

  return <Table ids={ids} schema={getSchema()} autoHeightMax={600} />
}

Management.defaultProps = {
  data: [],
}
